import { isEmpty, isNil } from 'lodash';
import { useContext, useEffect } from 'react';
import { MBButton } from '@shared/components/MBButton';
import { Menu, Submenu, useRootMenuContext } from '@shared/components/Menu';
import { Text } from '@shared/components/Text';
import { View } from '@shared/components/View';
import { MBLoadingIndicator } from '@shared/components/loading';
import { MBTextBody2 } from '@shared/components/typography';
import { useCardExport } from '@shared/scenes/cards/details/hooks/CardExport';
import { ColorThemeContext } from '@shared/styles';
import { i18n } from '@shared/util/i18n';

interface Props {
  entityId: string;
}

export function CardExportSubmenu({ entityId }: Props) {
  const { align } = useRootMenuContext();
  return (
    <Submenu align={align}>
      <Submenu.Trigger>
        <Menu.Item label={i18n('common.download')} />
      </Submenu.Trigger>
      <Submenu.Content>
        <CardExportContent entityId={entityId} />
      </Submenu.Content>
    </Submenu>
  );
}

function CardExportContent({ entityId }: Props) {
  const { response, createCardExport } = useCardExport();
  const colors = useContext(ColorThemeContext);
  const rootMenu = useRootMenuContext();

  useEffect(() => {
    createCardExport(entityId);
  }, [createCardExport, entityId]);

  useEffect(() => {
    if (!response.isLoading && !isNil(response.url)) {
      window.open(response.url, 'coast-pdf-' + response.url);
      rootMenu?.close();
    }
  }, [response.isLoading, response.url, rootMenu]);

  return (
    <Menu.Section>
      {response.isLoading && (
        <View center paddingVertical={2} paddingHorizontal={4} gap={1}>
          <MBLoadingIndicator />
          <Text size="body1">{i18n('common.downloadingDotDotDot')}</Text>
        </View>
      )}
      {!response.isLoading && !isEmpty(response.error) && (
        <View paddingHorizontal={2} paddingBottom={2} paddingTop={1}>
          <MBTextBody2 color={colors.error.foreground}>
            {i18n('errors.somethingWentWrong')}
          </MBTextBody2>
          <MBButton
            theme="normal"
            title={i18n('common.retry')}
            onPress={() => createCardExport(entityId)}
          />
        </View>
      )}
    </Menu.Section>
  );
}
